<template>
    <DsTableGrid :data="data">
        <DsTableGridColumn :label="$t('teamName')" prop="TeamName" expand />

        <DsTableGridColumn :label="$t('apps')" prop="Apps" width="150" />

        <DsTableGridColumn :label="$t('users')" prop="Users" width="150" />

        <DsTableGridColumn width="150">
            <DsTextButton data-qa="manage-button" @click="goToManageApp">
                {{ $t('manage') }}
            </DsTextButton>
        </DsTableGridColumn>
    </DsTableGrid>
</template>

<script>
export default {
    name: 'TeamTable',
    props: {
        data: {
            type: Array,
            required: true,
        },
    },

    methods: {
        goToManageApp() {
            // Navigate to the manage app page for the selected account
        },
    },
};
</script>
<i18n>
{
    "en-us": {
        "manage": "Manage",
        "users": "Users",
        "apps": "Apps",
        "teamName": "Team Name"
    }
}
</i18n>
